<template>
<div>
    <md-card>
        <header-form title="DETALHES DO FORNECEDOR" :btnHide="true">
            <div class="btn-title">
                <md-button :to="{name: 'fornecedoresRead'}" class="md-site md-just-icon md-round">
                    <i class="fas fa-list"></i>
                    <md-tooltip md-direction="top">Rede Credenciada</md-tooltip>
                </md-button>
            </div>
        </header-form>

        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-10 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">ID: </label>
                    <span class="text-secondary text-view">{{ fornecedor.id }}</span>
                </div>

                <div class="md-layout-item md-size-55 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">RAZAO SOCIAL: </label>
                    <span class="text-secondary text-view">{{ fornecedor.razao_social }}</span>
                </div>

                <div class="md-layout-item md-size-35 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">NOME FANTASIA: </label>
                    <span class="text-secondary text-view">{{ fornecedor.nome_fantasia }}</span>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CNPJ: </label>
                    <span class="text-secondary text-view">{{ fornecedor.cpf_cnpj }}</span>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">TELEFONE: </label>
                    <span class="text-secondary text-view">{{ fornecedor.telefone }}</span>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CELULAR: </label>
                    <span class="text-secondary text-view">{{ fornecedor.celular }}</span>
                </div>

                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <label class="text-secondary label-view">EMAIL: </label>
                    <span class="text-secondary text-view lowercase">{{ fornecedor.email }}</span>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CEP: </label>
                    <span class="text-secondary text-view">{{ fornecedor.cep }}</span>
                </div>

                <div class="md-layout-item md-size-70 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">RUA: </label>
                    <span class="text-secondary text-view">{{ fornecedor.rua }}</span>
                </div>

                <div class="md-layout-item md-size-10 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">Nº: </label>
                    <span class="text-secondary text-view">{{ fornecedor.num }}</span>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-35 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">COMPLEMENTO: </label>
                    <span class="text-secondary text-view">{{ fornecedor.complemento }}</span>
                </div>

                <div class="md-layout-item md-size-30 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">BAIRRO: </label>
                    <span class="text-secondary text-view">{{ fornecedor.bairro }}</span>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">CIDADE: </label>
                    <span class="text-secondary text-view">{{ fornecedor.cidade }}</span>
                </div>

                <div class="md-layout-item md-size-10 md-xsmall-size-100 uppercase">
                    <label class="text-secondary label-view">UF: </label>
                    <span class="text-secondary text-view">{{ fornecedor.uf }}</span>
                </div>
            </div>
        </md-card-content>
    </md-card>

    <md-card v-if="fornecedor.mapa">
        <md-card-content>
            <iframe :src="fornecedor.mapa" width="100%" frameborder="0"></iframe>
        </md-card-content>
        <md-card-header>
            <div class="md-title">Mapa</div>
            <div class="md-subhead">Click no mapa para visualizar</div>
        </md-card-header>
    </md-card>
</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import preLoader from '@/config/mixins/preLoader';
import Pagamento from '@/config/mixins/print/pagamento'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao,
            fornecedor: {},
        }
    },

    created() {
        this.getFornecedor();
    },

    mixins: [Notify, preLoader, Pagamento],

    methods: {
        getFornecedor() {
            this.$http.get(this.$urlAPI + 'empresas/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.fornecedor = response.data.dados[0];
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    }
};
</script>
